var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-progress-circular',{staticClass:"ma-4",attrs:{"color":"primary","indeterminate":""}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }